import React from 'react';
import styled from 'styled-components';
import { ButtonTertiary, cssColorValue, IconArrowLeft, IconArrowRight, screenMdMin, spacer24, spacer8, Type, } from '@spotify-internal/encore-web';
import { hexToRgba } from '../colorConversion';
import { withoutProps } from '../../ui/utils';
import { TWO_COLUMN_MAX_WIDTH } from './Grid';
import { useFrodorModules } from '../../Context/FrodorModulesProvider';
const Container = styled.div `
  display: flex;
  align-items: center;

  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    justify-content: center;
  }
`;
const CarouselNavStatus = styled(Type).attrs({
    variant: 'viola',
    semanticColor: 'textBase',
}) `
  padding-inline: ${spacer8};
  @media (min-width: ${screenMdMin}) {
    order: 2;
  }
`;
const NavArrow = styled(withoutProps(ButtonTertiary, 'hoverColor')) `
  transition: background-color 0.2s ease-in-out;
  :focus,
  :focus-visible {
    border-bottom-color: ${cssColorValue('textBase')};
  }
  :hover:not(:disabled) {
    background-color: ${({ hoverColor }) => hoverColor
    ? hexToRgba(hoverColor, 0.08)
    : cssColorValue('backgroundTintedBase')};
  }

  @media (min-width: ${screenMdMin}) {
    order: 1;
    svg {
      height: ${spacer24};
      width: ${spacer24};
    }
  }
`;
export const CarouselNav = ({ index, total, handlePrev, handleNext, hexColor = '', allowLooping = false, useControlNumbers = true, }) => {
    const { dir } = useFrodorModules();
    return (React.createElement(Container, null,
        React.createElement(NavArrow, { onClick: handlePrev, disabled: !allowLooping && index <= 1, iconOnly: () => dir === 'ltr' ? (React.createElement(IconArrowLeft, { semanticColor: "textBase", iconSize: 32 })) : (React.createElement(IconArrowRight, { semanticColor: "textBase", iconSize: 32 })), hoverColor: hexColor, "aria-label": "previous" }),
        useControlNumbers && (React.createElement(CarouselNavStatus, null, `${index} / ${total}`)),
        React.createElement(NavArrow, { onClick: handleNext, disabled: !allowLooping && index >= total, iconOnly: () => dir === 'ltr' ? (React.createElement(IconArrowRight, { semanticColor: "textBase", iconSize: 32 })) : (React.createElement(IconArrowLeft, { semanticColor: "textBase", iconSize: 32 })), hoverColor: hexColor, "aria-label": "next" })));
};
